import { useEffect, useState } from "react"
import { getAbVariant } from "components/SpotCounselling/redux/SpotCounsellingApi"

export default function useABTesting(variantId: string) {
  // 0 -> unset or loading, 1-> original, 2-> experimental
  const [abVariant, setAbVariant] = useState(0)

  const getVariantData = async () => {
    const variant = await getAbVariant(variantId)
    if (variant && variant.data) {
      setAbVariant(variant.data)
    } else {
      setAbVariant(1)
    }
  }
  useEffect(() => {
    getVariantData()
  }, [])

  return { abVariant }
}
